{
  "name": "36ed2-rationalised-to-7lim",
  "description": "Octave divided into 36 equal steps rationalised to 7-limit HEJI notes.",
  "scale": [
    "64/63",
    "28/27",
    "256/243",
    "243/224",
    "567/512",
    "9/8",
    "8/7",
    "7/6",
    "32/27",
    "2048/1701",
    "896/729",
    "81/64",
    "9/7",
    "21/16",
    "4/3",
    "256/189",
    "112/81",
    "729/512",
    "81/56",
    "189/128",
    "3/2",
    "32/21",
    "14/9",
    "128/81",
    "729/448",
    "1701/1024",
    "27/16",
    "12/7",
    "7/4",
    "16/9",
    "1024/567",
    "448/243",
    "243/128",
    "27/14",
    "63/32",
    "1200.0"
  ],
  "key_colors_mode": "manual",
  "short_description": "35-MT_Helmholtz",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "C",
    "C",
    "D",
    "D",
    "C",
    "D",
    "D",
    "D",
    "E",
    "E",
    "E",
    "F",
    "E",
    "E",
    "F",
    "F",
    "F",
    "G",
    "F",
    "F",
    "G",
    "G",
    "G",
    "A",
    "A",
    "G",
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "C",
    "B",
    "B",
    "C"
  ],
  "note_colors": [
    "#ff9e9e",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#bfaaa9",
    "#d3c6c5",
    "#ffffff",
    "#e5b9bb",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#dee2da",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#bfaaa9",
    "#d3c6c5",
    "#ffffff",
    "#e5b9bb",
    "#ffe5e5"
  ],
  "equivSteps": 36,
  "fundamental": 440,
  "reference_degree": 27,
  "center_degree": 0,
  "rSteps": 6,
  "drSteps": 5,
  "hexSize": 42,
  "rotation": -21.2,
  "lumatone_anchor_note": 13,
  "lumatone_anchor_channel": 3
}
